/**
 * Competence List Component
 *
 * @module @features/departments/components/CompetenceList
 */

import React from 'react';
import type { Employee } from '@shared/types';
import styles from '../MyDepartments.module.css';

/**
 * Props for CompetenceList component
 */
export interface CompetenceListProps {
    employee: Employee | undefined;
}

/**
 * Displays employee competence list
 */
export function CompetenceList({
    employee,
}: CompetenceListProps): React.ReactElement {
    return (
        <div className={styles.competenceList}>
            {Object.values(employee?.traitNames ?? {}).map((trait, index) => (
                <div
                    key={trait ?? index}
                    className={styles.competenceItem}
                >
                    <span className={styles.competenceIcon}>★</span>
                    <span>{trait}</span>
                </div>
            ))}
        </div>
    );
}
